export const FEATURE_VISIBILITY_GROUPS = [
  {
    key: 'dashboard',
    label: 'Panel',
    items: [
      { key: 'genelDurum', label: 'Genel Durum' },
    ],
  },
  {
    key: 'devamsizlik',
    label: 'Devamsızlık',
    items: [
      { key: 'devamsizlikYonetimi', label: 'Devamsızlık Yönetimi' },
      { key: 'devamsizlikDurumu', label: 'Devamsızlık Durumu' },
    ],
  },
  {
    key: 'odev',
    label: 'Ödev',
    items: [
      { key: 'odev', label: 'Ödev Yönetimi' },
      { key: 'odevDurumlari', label: 'Ödev Durumları' },
      { key: 'odevDurumuOzeti', label: 'Ödev Durumu Özeti' },
    ],
  },
  {
    key: 'calisma',
    label: 'Çalışma Günlüğü',
    items: [
      { key: 'calismaGunlugu', label: 'Çalışma Günlüğü' },
      { key: 'miniGorevler', label: 'Mini Görevler' },
    ],
  },
  {
    key: 'deneme',
    label: 'Deneme',
    items: [
      { key: 'denemePlanlama', label: 'Deneme Planlama' },
      { key: 'sinavSonuclari', label: 'Deneme Sonuçları' },
    ],
  },
  {
    key: 'odeme',
    label: 'Ödeme',
    items: [
      { key: 'odemePlani', label: 'Ödeme Planı' },
      { key: 'odemeIstatistik', label: 'Ödeme İstatistikleri' },
    ],
  },
  {
    key: 'iletisim',
    label: 'İletişim',
    items: [
      { key: 'sablonDurumu', label: 'Şablon Durumu' },
      { key: 'mesajlar', label: 'Mesajlar' },
      { key: 'gelenMesajlar', label: 'Gelen Mesajlar' },
      { key: 'veliOptInDurumu', label: 'Veli kayıt durumu' },
      { key: 'playground', label: 'Playground' },
    ],
  },
  {
    key: 'yonetim',
    label: 'Yönetim',
    items: [
      { key: 'veliOgrenci', label: 'Veli-Öğrenci Yönetimi' },
      { key: 'ogretmen', label: 'Öğretmen Yönetimi' },
      { key: 'yonetici', label: 'Admin Yönetimi' },
      { key: 'sinif', label: 'Şube Yönetimi' },
      { key: 'ders', label: 'Ders Yönetimi' },
      { key: 'dersProgrami', label: 'Ders Programı' },
      { key: 'ogretmenDersProgrami', label: 'Öğretmen Ders Programı' },
      { key: 'ogretmenHatirlatma', label: 'Öğretmen Hatırlatmaları' },
      { key: 'veliHatirlatma', label: 'Veli Hatırlatmaları' },
    ],
  },
  {
    key: 'ogrenci',
    label: 'Öğrenci',
    items: [
      { key: 'ogrenci360', label: 'Öğrenci360' },
      { key: 'puanlar', label: 'Puanlar' },
    ],
  },
  {
    key: 'kutuphane',
    label: 'Kütüphane',
    items: [
      { key: 'kutuphanem', label: 'Kütüphanem' },
      { key: 'kutuphaneOkumaIsaretle', label: 'Kitap Okundu İşaretle' },
      { key: 'kitap', label: 'Kitaplar' },
      { key: 'kutuphaneOgrenciIstatistik', label: 'Öğrenci İstatistikleri' },
    ],
  },
  {
    key: 'deger',
    label: 'Değer Kataloğu',
    items: [
      { key: 'degerTema', label: 'Değer Temaları' },
      { key: 'degerProgram', label: 'Değer Programı' },
      { key: 'degerSonuc', label: 'Değerlendirme Sonuçları' },
    ],
  },
  {
    key: 'gozlem',
    label: 'Gözlem',
    items: [
      { key: 'gozlemGunlugu', label: 'Gözlem Günlüğü' },
      { key: 'gozlemOzeti', label: 'Gözlem Özeti' },
    ],
  },
  {
    key: 'maarif',
    label: 'Öğrenme Çıktısı',
    items: [
      { key: 'ogrenmeCiktisiDegerlendirme', label: 'Öğrenme Çıktısı Değerlendirme' },
      { key: 'ogrenmeCiktisiOzet', label: 'Öğrenme Çıktısı Özeti' },
      { key: 'ogrenmeCiktisiOgrenciPerformans', label: 'Öğrenci Performansı' },
    ],
  },
  {
    key: 'beslenme',
    label: 'Beslenme',
    items: [
      { key: 'beslenmeYonetimi', label: 'Beslenme Değerlendirme' },
      { key: 'beslenmeDurumu', label: 'Beslenme Durumu' },
    ],
  },
  {
    key: 'materyal',
    label: 'Materyal',
    items: [
      { key: 'materyalYonetimi', label: 'Öğrenci Materyalleri' },
      { key: 'materyalDurumu', label: 'Materyal Durumu' },
    ],
  },
  {
    key: 'okulSinavlari',
    label: 'Okul Sınavları',
    items: [
      { key: 'okulSinavSonuclari', label: 'Okul Sınav Sonuçları' },
      { key: 'okulSinavOrtalamalari', label: 'Ortalama Sıralaması' },
    ],
  },
  {
    key: 'genelDegerlendirme',
    label: 'Ders Değerlendirmeleri',
    items: [
      { key: 'genelDegerlendirmeKayit', label: 'Ders Değerlendirmeleri' },
      { key: 'genelDegerlendirmeTablo', label: 'Sonuç Tablosu' },
    ],
  },
  {
    key: 'okumaHizi',
    label: 'Okuma Hızı',
    items: [
      { key: 'okumaHiziKayit', label: 'Okuma Hızı Testi' },
      { key: 'okumaHiziTablo', label: 'Sonuç Tablosu' },
    ],
  },
  {
    key: 'storybook',
    label: 'Hikaye Kitabı Değerlendirme',
    items: [
      { key: 'storyBookEvaluationKayit', label: 'Sınav Kayıt' },
      { key: 'storyBookEvaluationTablo', label: 'Sonuç Tablosu' },
    ],
  },
  {
    key: 'yildizBahcem',
    label: 'Yıldız Bahçem',
    items: [
      { key: 'yildizBahcem', label: 'Yıldız Bahçem' },
      { key: 'yildizBahcemHizli', label: 'Yıldız Bahçem Hızlı' },
      { key: 'yildizBahcemSonuc', label: 'Kriter Sonuçları' },
      { key: 'yildizBahcemKriter', label: 'Kriter Düzenleme' },
    ],
  },
  {
    key: 'vks',
    label: 'VKS',
    items: [
      { key: 'gelecekOrmani', label: 'Gelecek Ormanı' },
    ],
  },
];

export function getFeatureVisibility(settings) {
  return settings?.ui?.feature_visibility || {};
}

export function isFeatureVisible(settings, featureKey, role) {
  if (!featureKey) {
    return true;
  }
  const normalizedRole = String(role || '').trim().toLowerCase();
  if (normalizedRole === 'superadmin') {
    return true;
  }
  if (normalizedRole !== 'admin' && normalizedRole !== 'teacher') {
    return true;
  }
  const featureVisibility = getFeatureVisibility(settings);
  const featureConfig = featureVisibility?.[featureKey];
  if (!featureConfig || typeof featureConfig !== 'object') {
    return true;
  }
  const decision = featureConfig[normalizedRole];
  return typeof decision === 'boolean' ? decision : true;
}

export function updateFeatureVisibility(settings, featureKey, role, visible) {
  const normalizedRole = String(role || '').trim().toLowerCase();
  const nextSettings = {
    ...(settings || {}),
    ui: {
      ...((settings || {}).ui || {}),
      feature_visibility: {
        ...getFeatureVisibility(settings),
        [featureKey]: {
          ...(getFeatureVisibility(settings)[featureKey] || {}),
          [normalizedRole]: Boolean(visible),
        },
      },
    },
  };
  return nextSettings;
}
